import fetch from '../../utils/fetch'
import Cookies from "js-cookie";
console.log(Cookies.get('Admin-Token'),'Cookies.get');

// console.log( getCookie(Admin-Token));
export function getBasicConfig(id) {
    return fetch({
        url: '/api/area/config/' + id,
        method: 'GET',
    })
}

export function getParkRsLoginTo(data) {
    return fetch({
        url: '/api/verify/rsLoginTo',
        method: 'POST',
        params: data
    })
}

export function getRsParkList(data) {
    return fetch({
        url: '/api/rsPark/list',
        method: 'GET',  
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
    })
}
export function getRSparkInfo(data) {
    return fetch({
        url: `/api/rsPark/parkInfo/${data}`,
        method: 'GET',  
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
    })
}


export function getManagerApplyPark(data) {
    return fetch({
        url: `/api/rsPark/managerApplyPark`,
        method: 'POST',
        data,  
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
    })
}

export function getManagerOffPark(data) {
    return fetch({
        url: `/api/rsPark/managerOffPark`,
        method: 'POST',
        data,  
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
    })
}
export function getManagerOffParkInfo(data) {
    return fetch({
        url: `/api/rsPark/parkInfo/${data.parkingName}/${data.lotId}`,
        method: 'GET',
      
      
    })
}
export function getUserInfoByOpenId(openId) {
    return fetch({
        url: `/api/rsPark/getUserInfoByOpenId/${openId}`,
        method: 'GET',
      
      
    })
}



export function getApplyParkIn(data) {
    return fetch({
        url: `/api/rsPark/pass/applyParkIn`,
        method: 'POST',
        data
      
    })
}
export function getUnionOrder(data) {
    return fetch({
        url: `/api/pay/rs/unionOrder`,
        method: 'POST',
        data
      
    })
}
//管理员确认进场
export function getManagerSubmit(data) {
    return fetch({
        url: `/api/rsPark/managerSubmit`,
        method: 'POST',
        data,
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
      
    })
}

//检测用户是否需要付款
export function getApplyParkOff(data) {
    return fetch({
        url: `/api/rsPark/pass/applyParkOff`,
        method: 'POST',
        data,
       
      
    })
}
//管理员确认付款离场
export function getManagerSubmitOff(data) {
    return fetch({
        url: `/api/rsPark/managerSubmitOff`,
        method: 'POST',
        data,
        headers: { 'Authorization': 'Bearer ' + Cookies.get('Token') }
      
    })
}


